/**
 * Resolves the runtime cluster id from a data source object. Used to hydrate the
 * `RuntimeSelection` read-only display in edit mode and to seed the create-form's
 * `clusterId` state when a partially-loaded source becomes fully available.
 *
 * Supports both response shapes:
 *   - `{ cluster: { id } }` (the canonical shape returned by /data_sources/{id})
 *   - `{ cluster_id }` (the legacy flat shape from older endpoints)
 *
 * Returns null when the source is missing or carries neither field.
 */
export function getClusterIdFromSource(
  source:
    | { cluster?: { id?: number | string | null }; cluster_id?: number | string | null }
    | null
    | undefined,
): number | string | null {
  if (!source) return null;
  return source.cluster?.id ?? source.cluster_id ?? null;
}
